(function() {

	var decimalPlaces = function(x) {
		var parts = x.toString().split('.');
		if (parts.length < 2) {
			return 0;
		}
		return parts[1].length;
	};

	var correctionFactor = function(x, y) {
		var xd = decimalPlaces(x), yd = decimalPlaces(y);
		return Math.pow(10, (xd > yd ? xd : yd));
	};

	AccurateMath = {
		// Modulus without rounding errors		
		mod: function(x, y) {
			var cf = correctionFactor(x, y);
			return Math.round((x * cf) % (y * cf)) / cf;
		}
	};
})();